export default __webpack_public_path__ + "static/media/razmernaya_setka_odezhda.ed9cb741.svg";